/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectFinancingStakholder } from '../../models/project-financing-stakholder';
import { ProjectImportance } from '../../models/project-importance';
import { ProjectSection } from '../../models/project-section';
import { ProjectStates } from '../../models/project-states';
import { ProjectStatus } from '../../models/project-status';
import { ProjectType } from '../../models/project-type';
import { UpdateProjectCommandResult } from '../../models/update-project-command-result';

export interface ApiProjectUpdateProjectPatch$Params {
      body?: {
'Id': string;
'Name': string;
'CodeNumber'?: string;
'ManagerId'?: string;
'EstimatedStartDate'?: string;
'EstimatedEndDate'?: string;
'ActualStartDate'?: string;
'ActualEndtDate'?: string;
'Description'?: string;
'ProjectStatus'?: ProjectStatus;
'ProjectType'?: ProjectType;
'EstimatedCost'?: number;
'ActualCost'?: number;
'Lat'?: number;
'Lon'?: number;
'ProgramId'?: number;
'ConstructionId'?: string;
'ConsultingId'?: string;
'StackholderId'?: number;
'ProjectState'?: ProjectStates;
'ConsultativeManagerId'?: string;
'ConstructionManagerId'?: string;
'Priority'?: number;
'Importance'?: ProjectImportance;
'FinancingStakholder'?: ProjectFinancingStakholder;
'Section'?: ProjectSection;
'Notes'?: string;
'Year'?: number;
'QuarterId'?: string;
'ContractNumber'?: string;
'VatValue'?: number;
'Attachments'?: Array<Blob>;
'CategoryId'?: string;
'ContainerId'?: string;
}
}

export function apiProjectUpdateProjectPatch(http: HttpClient, rootUrl: string, params?: ApiProjectUpdateProjectPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectUpdateProjectPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectCommandResult>;
    })
  );
}

apiProjectUpdateProjectPatch.PATH = '/api/Project/UpdateProject';
